import { Link } from 'react-router-dom'
import useAuth from '../../usecases/useAuth'
import { notification } from 'antd'

const FooterPointCharge = () => {
  const { logout } = useAuth()
  const apiURL = process.env.REACT_APP_API_URL
  const policyURL = `${apiURL}/page/policy`
  const rulesURL = `${apiURL}/page/rules`
  const handleLogout = async () => {
    try {
      await logout()
    } catch (err) {
      notification.error({
        message: 'ログアウト失敗',
        description: '認証に失敗しました'
      })
    }
  }
  return (
    <div>
      <div className='flex justify-center'>
        <Link to={policyURL}>
          <p className='text-[#00D4FF] text-lg underline'>
            プライバシーポリシー
          </p>
        </Link>
      </div>
      <div className='flex justify-center'>
        <Link to={rulesURL}>
          <p className='text-[#00D4FF] text-lg underline'>
            特定商取引法に基づく表記
          </p>
        </Link>
      </div>
      <div className='flex justify-center'>
        <p
          onClick={handleLogout}
          className=' cursor-pointer text-[#00D4FF] text-lg underline'
        >
          ログアウトする
        </p>
      </div>
    </div>
  )
}

export default FooterPointCharge
